import { TZDate } from '@date-fns/tz';
import { formatInTimeZone } from 'date-fns-tz';

const E_PRESCRIPTION_TIME_ZONE = 'Europe/Prague';
const CANNABIS_VALIDITY_DAYS = 30;

export function getEPrescriptionValidTo(issuedAt: Date, containsCannabis: boolean): Date {
    const validTo = TZDate.tz(E_PRESCRIPTION_TIME_ZONE, issuedAt);
    if (containsCannabis) {
        validTo.setDate(validTo.getDate() + CANNABIS_VALIDITY_DAYS);
    } else {
        validTo.setMonth(validTo.getMonth() + 1);
    }
    return new Date(validTo.getTime());
}

// SÚKL uses calendar dates, not timestamps; ignore time of day and daylight-saving transitions.
export function formatEPrescriptionDate(date: Date): string {
    return formatInTimeZone(date, E_PRESCRIPTION_TIME_ZONE, 'yyyy-MM-dd');
}
